module.exports = __webpack_public_path__ + "static/media/report_calendar.eb2427cc.svg";